module.exports = __webpack_public_path__ + "img/icon_cases.5d225612.png";